export default function toTop() {
    $ = jQuery;
    $('.js-to-top').on('click', () => {
        $('html, body').animate({
            scrollTop: $('html').offset().top
        });
    })
}